// extracted by mini-css-extract-plugin
module.exports = {"secondary":"TabLabel_secondary__2948h","selected":"TabLabel_selected__1IkQ_"};